import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { FREE_SPIN_GAMES_QUERY_KEY } from "./useGetFreeSpinGames";

export const FREE_SPIN_PROVIDERS_QUERY_KEY = [
  ...FREE_SPIN_GAMES_QUERY_KEY,
  "__providers__",
] as const;

/**
 * Providers that support free spins via the casino aggregator.
 * Confirmed by casino team — only these providers expose freespins_available
 * games through the casino admin games endpoint.
 */
const FREE_SPIN_PROVIDERS: string[] = ["alea", "bgaming", "threeoaks"];

export const useGetFreeSpinProviders = (
  enabled = true,
): UseQueryResult<string[], Error> =>
  useQuery<string[], Error>({
    queryKey: [...FREE_SPIN_PROVIDERS_QUERY_KEY],
    queryFn: () => Promise.resolve(FREE_SPIN_PROVIDERS),
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
